import React, { useState } from 'react';
import { Box, HStack, VStack } from "native-base";
import SimpleInput from './SimpleInput';
import AppText from './AppText';
import { isMobile } from '../../services/Helpers';
import { Colors } from '../../styles/Colors';
import { GlobalStyleAttributes } from '../../styles/GlobalStyles';
import { Collapse } from 'antd';
import InfoTooltip from "./InfoTooltip";
import { useMemo } from 'react';
import FoldableSettingSection from './FoldableSettingSection';

/**
 *
 * @param {width, containerProps, label, labelProps, error, errorProps, helper, helperProps, topEndElement, infoTooltip, children, collapsable, description} props
 * @returns ReactElement
 */
const FormInput = (props) => {
    const { width, containerProps, label, labelProps, error, errorProps, helper, helperProps, topEndElement, infoTooltip, children, collapsable, collapseProps, description, errorHeight, required , validationSchema, name, iconRender, ...rest } = props;
    const labelProp = labelProps || {};
    const errorProp = errorProps || {};
    const containerProp = containerProps || {};
    const helperProp = helperProps || {};
    const formWidth = width || (isMobile ? '100%' : '50%');
    const labelStyle = {
        ...(labelProp.style || {}),
        ...(infoTooltip ? {display: 'flex', alignItems: 'center'} : {}),
    };
    const [collapseOpen, setCollapseOpen] = useState(false);
    const isRequired = useMemo(() => required ||  (validationSchema && name && validationSchema.fields[name]?.spec?.presence === 'required'), [required, validationSchema])

    if (collapsable) {
        return (
            <Box mb={'0.5rem'} width={'100%'}>
                <FoldableSettingSection
                    isOpen={collapseOpen}
                    onToggle={() => setCollapseOpen(!collapseOpen)}
                    header={`${label}${isRequired ? '*' : ''}`}
                    infoTooltip={infoTooltip}
                    summary={!collapseOpen && description}
                    error={error}
                    helper={helper}
                    extraHeader={topEndElement && <div style={{marginInlineStart: 'auto', marginInlineEnd: '0.5rem'}}>{topEndElement}</div>}
                >
                    <VStack>
                        {children || <SimpleInput status={error ? 'error' : null} iconRender={iconRender} {...rest} />}
                    </VStack>
                </FoldableSettingSection>
            </Box>
        );
    }

    return (
        <VStack mb={'1rem'} space={'0.2rem'} width={formWidth} {...containerProp}>
            {(label || topEndElement) &&
                <HStack width={'100%'} alignItems={'center'} justifyContent={'space-between'}>
                    {label &&
                        <AppText fontSize={GlobalStyleAttributes.fonts.infoText} mediumFont width='max-content' {...labelProp} style={labelStyle}>
                            {`${label}${isRequired ? '*' : ''}`}
                            {infoTooltip && <InfoTooltip title={infoTooltip}/>}
                        </AppText>}
                    {topEndElement}
                </HStack>}
            {children || <SimpleInput status={error ? 'error' : null} iconRender={iconRender} {...rest} />}
            <VStack height={errorHeight ?? 0}>
                {helper && !error &&
                    <AppText color={Colors.newDesign.darkGrey} fontSize={GlobalStyleAttributes.fonts.infoText} {...helperProp}>
                        {helper}
                    </AppText>}
                {error &&
                    <AppText color={Colors.error} fontSize={GlobalStyleAttributes.fonts.infoText} width='max-content' mediumFont {...errorProp}>
                        {error}
                    </AppText>}
            </VStack>
        </VStack>
    );
};

export default FormInput;
